<template>
	<el-table
		v-bind:data="questionnaireTypeContent"
		:show-header="false"
		row-key="id"
		@row-click="expandRow"
		class="questionnaire-table"
		:expand-row-keys="expand"
		:cell-class-name="getCellClass"
		:row-class-name="getRowClass"
		empty-text="No questionnaires answered yet"
		style="width: 100%">

		
		<el-table-column prop="title" width="450">
			<template slot-scope="scope">
				<div>
					<div style="padding-left:20px;">
						<span class="flag-count" v-if="isSurvey && getProblemCount(scope.row.event) > 0">
							{{ getProblemCount(scope.row.event) }}
							<img src="./analysis/response/icon/flag-unresolved.png" class="flag-image">
						</span>
						<span class="flag-count" style="background-color: #E6FFEA" v-if="isSurvey && getResolvedCount(scope.row.event) > 0">
							{{ getResolvedCount(scope.row.event) }}
							<img src="./analysis/response/icon/flag-resolved.png" class="flag-image">
						</span>
						<div class="survey-in-event" v-if="eventId !== '' && scope.row.event.length && scope.row.event[0].hasOwnProperty('provider_survey') && scope.row.event[0].provider_survey">
							<img class="survey-icon" src="./icon/survey.svg">
							<strong class="ml-35">{{ getContentKey('questionnaire', scope.row.id, 'display_name') || getContentKey('questionnaire', scope.row.id, 'title') }}</strong>
						</div>
						<strong v-else>
							{{ getContentKey('questionnaire', scope.row.id, 'display_name') || getContentKey('questionnaire', scope.row.id, 'title') }}
						</strong>
						<span class="survey-taken-date" v-if="isSurvey && isAsked(scope.row) && getAnsweredDate(scope.row)" v-html="getAnsweredDate(scope.row)"></span>
						<div class="req-cnt" v-if="!isSurvey && scope.row.event.length && !scope.row.event[0].hasOwnProperty('provider_survey') && sentAndNotAnswered(scope.row)">
							Requested {{incomplete(scope.row)}}
						</div>
					</div>
					<EventList :patient="patient" :survey-data="scope.row"></EventList>
				</div>	
			</template>
		</el-table-column>

		<el-table-column>
			<template slot-scope="scope">
				<div v-if="!isSurvey && sentAndNotAnswered(scope.row)" class="incomplete-section">
					<div v-if="findIfQuestion(scope.row)" class="incomplete">
						<span class="not-answered-tag" v-if="!incomplete.hasOwnProperty('provider_survey')">Not answered</span>
					</div>
					<div v-else v-for="(incomplete, index) in scope.row.event" :key="index" class="incomplete">
						<span class="incomplete-text" v-if="incomplete.hasOwnProperty('provider_survey') && incomplete.provider_survey">incomplete</span>
						<span class="click-to-complete-text" v-if="incomplete.hasOwnProperty('provider_survey') && incomplete.provider_survey" @click="openLinkDirectly(incomplete)">Click to complete</span>
					</div>
				</div>
				<div v-else-if="!answered(scope.row)" class="not-answered-tag">
					Not answered
				</div>
				<div v-else class="scores">
					<div v-if="findIfSurvey(scope.row, patient.id)" class="score-cont">
						<div v-for="(score, index) in questionScores(scope.row, patient.id)" 
							:key="index"
							class="score">
							<span class="date">
								{{ formatDate(score.completed) }}
							</span>
							<span class="value" :style="(isSurvey || score.provider_survey) ? 'color: #709F34' : 'color: #833e93'">
								{{ score.score }}
							</span>
						</div>
					</div>
					<div v-else class="score-cont">
						<div v-for="(eventScrObjs, disp_title, index) in questionScores(scope.row, patient.id)" 
							:key="index"
							class="row-resp">
							<div v-if="eventScrObjs[0].computed_score === undefined && eventScrObjs[0].score === undefined" class="row-resp-inner-without-score">
								<div v-for="(respObj) in eventScrObjs" v-bind:key="respObj.id" class="resp-date-score">
									<span class="resp-date">{{ monDtFormat(respObj.completed, false, false) }}</span>
								</div>
							</div>
							<div v-else class="row-resp-inner">
								<span class="displ-title">{{ disp_title }} - </span>
								<div v-for="(respObj) in eventScrObjs" v-bind:key="respObj.id" class="resp-date-score">
									<span class="resp-score">{{ respObj.computed_score ? respObj.computed_score : respObj.score}}</span>
									<span class="resp-date">({{ monDtFormat(respObj.completed, false, false) }})</span>
								</div>
							</div>
							<!-- <div v-else class="row-resp-inner-without-score">
								<div v-for="(respObj) in eventScrObjs" v-bind:key="respObj.id" class="resp-date-score">
									<span class="resp-date">{{ monDtFormat(respObj.completed, false, false) }}</span>
								</div>
							</div> -->
						</div>
					</div>
				</div>
			</template>
		</el-table-column>
		
		<!-- Expandable message history list -->
		<el-table-column v-if="isSurvey && getUserType != 'observer'" width="150">
			<template slot-scope="scope" v-if="isAsked(scope.row)">
				<div v-if="answered(scope.row)" class="survey-date">
					<span>Last Answered by <br> On {{  formatDate(lastAnswered(scope.row)) }}, {{  formatTime(lastAnswered(scope.row)) }}</span> 
				</div>
				<div v-else class="survey-date">
					{{  formatDate(lastRequest(scope.row)) }}
					<div>{{  formatTime(lastRequest(scope.row)) }}</div>
				</div>
				
			</template>
		</el-table-column>

		<el-table-column width="150" v-if="!isSurvey">
			<template slot-scope="scope" v-if="scope.row.event.length">
				{{ getProviderNameById(scope.row.event[0].provider) }}
			</template>
		</el-table-column>

		<el-table-column width="180" v-if="isSurvey && getUserType !== 'observer'">
			<template slot-scope="scope">
				<el-button class="answer-now" v-if="!answered(scope.row) && !isAsked(scope.row)" @click.stop="$emit('answer-now', scope.row.id)" :disabled="getSurveyState[scope.row.id]">
					<LoadSpinner style="height:12px;width:12px;" type="survey" v-if="getSurveyState[scope.row.id]"></LoadSpinner>
					<span v-else>Answer Now</span>
				</el-button>
				<el-button :class="['respond-again',{'survey-expanded':expand.length && expand[0] === scope.row.id}]" v-else-if="(answered(scope.row) && incomplete(scope.row)) === 0 || !isAsked(scope.row)" @click.stop="$emit('answer-now', scope.row.id)" :disabled="getSurveyState[scope.row.id]">
					<LoadSpinner style="height:12px;width:12px;" type="survey" v-if="getSurveyState[scope.row.id]"></LoadSpinner>
					<span v-else>Respond Again</span>
				</el-button>
				<el-button class="complete-now" v-else-if="incomplete(scope.row) !== 0" @click="openLink(scope.row)">
					<span>Complete Now</span>
				</el-button>
			</template>
		</el-table-column>

		<el-table-column width="50">
			<template slot-scope="scope" v-if="answered(scope.row)">
				<div style="margin-top: 10px;">
					<span v-if="expand.length && expand[0] === scope.row.id" >
						<span v-if="isSurvey" class="up-arrow-survey">
							<UpArrowIcon></UpArrowIcon>
						</span>
						<span v-else>
							<img src="../../images/up-arrow.png" width="21px" height="21px">
						</span>
					</span>
					<span v-else>
						<img src="../../images/down-arrow.png" width="21px" height="21px">
					</span>
				</div>
			</template>
		</el-table-column>

		<el-table-column type="expand" width="1">
			<template slot-scope="scope">
				<QuestionnaireAnalysis
					v-if="answered(scope.row)"
					v-bind:id="scope.row.id"
					v-bind:questionnaire="scope.row.event"
					v-bind:patient="patient"
					:is-survey="isSurvey">
				</QuestionnaireAnalysis>
			</template>
		</el-table-column>

	</el-table>

</template>
<script>
import CardTable from '../component/table'
import { mapState, mapGetters, mapActions } from 'vuex'

import QuestionnaireCalcMixin from '../mixin/questionnaire-calc'
import QuestionnaireAnalysis from './analysis/Analysis'
import LoadSpinner from '@/module/component/icon/LoadSpinner.vue'
import EventList from './EventList.vue'
import Icons from '../questionnaire/analysis/response/icon'

export default {
	name: 'patient-questionnaire-card-table',
	extends: CardTable,

	mixins: [QuestionnaireCalcMixin],

	props: {
		patient: {
			type: Object,
			required: true
		},
		questionnaire: {
			type: Array
		},
		isSurvey: {
			type: Boolean,
			default: false
		},
		profileQuestionnairesId: {
			type: Array
		}
	},

	data() {
		return {
			edit: false,
			expand: []
		}
	},

	methods: {
		openLinkDirectly(obj) {
			if (obj.hasOwnProperty('short_url'))
				window.open(obj.short_url, '_blank')
		},
		openLink(row) {
			window.open(this.incompleteLink(row), '_blank')
		},
		getProfileFromProvider(providerId) {
			if(this.patient.profile_map) {
				const providerProfile = this.patient.profile_map.find((providerProfile) => providerProfile.includes(providerId))
				if(providerProfile)
					return '(' + this.getContentKey('profile', providerProfile.split(':')[1], 'title') + ')'
			}
			else
				return '(' + this.getContentKey('profile', this.patient.profile[0], 'title') + ')'
		},
		hasFlagError(eventList) {
			return eventList.some((event) => event.problem ? event.problem.some(({resolved_time}) => !resolved_time) : false)
		},
		getProblemCount(eventList) {
			let problemCount = 0
			eventList.forEach(event => {
				if (event.hasOwnProperty('problem') && event.problem)
					problemCount += event.problem.filter(({resolved_time}) => !resolved_time).length
			})
			return problemCount
		},
		getResolvedCount(eventList) {
			let resolvedCount = 0
			eventList.forEach(event => {
				if (event.hasOwnProperty('problem') && event.problem)
					resolvedCount += event.problem.filter(({resolved_time}) => resolved_time).length
			})
			return resolvedCount
		},
		monDtFormat(date) {
			const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
			const exDt = new Date(date)
			var month = months[exDt.getMonth()]
			var date = exDt.getDate()
			return month + " " + date
		}
	},

	computed: {
		...mapGetters('provider', [
			'getSurveyState'
		]),
		...mapGetters(['getUserType']),
		questionnaireType() {
			return this.typeMap(this.questionnaire)
		},
		questionnaireTypeContent() {
			let questContent = this.questionnaireType.map((type) => ({
				...type,
				content: this.getContent('questionnaire', type.id)
			}))
			if(this.isSurvey) {
				let questFull = this.profileQuestionnairesId.map((quesId) => {
					const questFound = questContent.find(({ id }) => quesId === id)
					if(questFound)
						return questFound
					return {
						id: quesId,
						content: this.getContent('questionnaire', quesId),
						event: []
					}
				})
				questContent = questFull
			}
			return questContent
			
		}
	},

	components: {
		QuestionnaireAnalysis,
		LoadSpinner,
		EventList,
		...Icons
	}
}
</script>

<style lang="scss">
.flag-image {
	width: 8px;
    height: 10px;
}
.flag-count {
	width: 36px;
	height: 20px;
	padding: 5px 8px;
	background: #FFEBEB;
	border-radius: 10px;
	font-weight: 400;
	font-size: 12px;
	line-height: 15px;
	text-align: center;
	color: #333333;
	margin-right: 10px;
}
.survey-in-event {
	display: flex;
	align-items: center;
	gap: 8px;
	&>strong {
		font-weight: 600;
		color: #709F34;
	}
}

.not-answered-tag {
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 16px;
	color: #999999;
	background-color: #eeeeee;
	width: 84px;
    padding: 2px 5px;
}
.vital-icon {
	width: 40px;
	height: 40px;
	float: left;
}
.questionnaire-cell {
	cursor: pointer;
	.el-table__expand-icon {
		transform: rotate(90deg);
		height: 24px;
		width: 24px;
		border-radius: 50%;
		border: 1px solid #cccccc;
		color: #666666;
		font-weight: bold;
		.el-icon {
			font-weight: bold;
			margin-left: -6px;
		}
	}
	.el-table__expand-icon--expanded {
		transform: rotate(-90deg);
		background-color: #833e93;
		color: #ffffff;
		border: 1px transparent;
	}
	.survey-theme {
		color: #709F34 !important;
		padding-left: 34px;
	}
	.survey-date {
		color: #828282;
		font-size: 10px;
		text-align: right;
		float: right;
		line-height: 16px;
	}
	.survey-taken-date{
		font-size: 14px;
		font-weight: 400;
		color: #666666;
		word-break: break-word;
	}
	.expand-holder {
		padding: 3px;
		border: 1px solid #CCCCCC;
		border-radius: 50%;
		cursor: pointer;
		width: 10px;
		height: 10px;
		padding-top: 3px;
		.el-icon-arrow-down {
			vertical-align: text-top;
			color: #666666;
		}
	}
}
.expanded .expand-holder .el-icon-arrow-down {
	transform: rotate(180deg);
}
.el-table--enable-row-hover .el-table__body tr:hover > td.questionnaire-cell.survey-cell {
	background-color: #ffffff;
}
.questionnaire-cell.survey-cell {
	cursor: default;
	background-color: #ffffff;
	&.first .cell{
		padding-left: 0;
	}
}

.el-table tr.not-yet {
	background-color: #f8f8f8;
	.questionnaire-cell.survey-cell {
		background-color: #f8f8f8;
	}
	.el-table__expand-column {
		display: none;
	}
}
.el-table tr.answered {
	background-color: #edf8df;
	.questionnaire-cell.survey-cell {
		background-color: #edf8df;
	}
}
.el-table--enable-row-hover .el-table__body tr.not-yet:hover > td.questionnaire-cell.survey-cell {
	background-color: #f8f8f8;
}
.el-table--enable-row-hover .el-table__body tr.answered:hover > td.questionnaire-cell.survey-cell {
	background-color: #edf8df;
}
.questionnaire-table table.el-table__body {
	background-color: #f8f8f8;
}
</style>

<style lang="scss" scoped>

.incomplete-section {
	display: flex;
	flex-wrap: wrap;
	.incomplete {
		z-index: 101;
		display: flex;
		flex-direction: row;
		padding-right: 10px;
		padding-left: 10px;
		border-right: 1px solid #eceef6;
		.date {
			font-size: 11px;
			color: #666666;
		}
		.incomplete-text {
			width: 82px;
			height: 15px;
			background: #DA4E4E;
			border-radius: 2px;
			font-weight: 600;
			font-size: 12px;
			line-height: 12px;
			text-transform: uppercase;
			color: #FFFFFF;
			padding: 2px 2px 2px 4px;
			display: inline;
			margin-right: 5px;
		}
		.click-to-complete-text {
			font-weight: 500;
			font-size: 12px;
			line-height: 18px;
			color: #666666;
			cursor: pointer;
			display: inline-block;
		}
	}
	.incomplete:last-child {
		border-right: none;
	}
}
.scores {
	display: flex;
	flex-wrap: wrap;
	.score {
		display: flex;
		flex-direction: column;
		padding-right: 10px;
		padding-left: 10px;
		border-right: 1px solid #eceef6;
		.date {
			font-size: 11px;
			color: #666666;
			margin-top: 3px;
		}
		.value {
			font-size: 17px;
			font-weight: 700;
		}
	}
	.score:last-child {
		border-right: none;
	}

	.score-cont {
		width: 100%;
		background-color: #FAF5FC;
		display: inline;
		word-break: break-word;
		padding: 0 10px;

		.row-resp {
			display: inline;

			.row-resp-inner {
				display: inline;
				.displ-title {

				}
				.resp-date-score {
					display: inline;
					// margin: 0 3px;
					margin-right: 4px;
					.resp-score {
						font-weight: bold;
						color: #833E93;
					}
					.resp-date {
						color: #828282;
						margin-left: 2px;
					}
				}
				.resp-date-score:not(:last-child)::after {
					content:",";
					width:2px;
					height:2px;
					border-radius:50%;
					// background: #525252;
					display:inline-block;
				}
			}

			.row-resp-inner-without-score {
				display: inline;
				.resp-date-score {
					display: inline;
					margin-right: 4px;
					border-right: 1px solid #E2E2E2;
					color: #666666;
					padding-right: 5px;
				}
				.resp-date-score:last-child {
					border-right: none;
					padding-right: 0px;
				}
			}
		}

		.row-resp:not(:last-child)::after {
			content:"\A";
			width:3px;
			height:3px;
			border-radius:50%;
			background: #333333;
			display:inline-block;
			position: relative;
			bottom: 3px;
			margin: 0 7px 0 3px;
		}
	}

	.score-cont:has(> .row-resp > .row-resp-inner-without-score) {
		background-color: white;
	}
}
.up-arrow-survey {
	width: 21px;
	height: 21px;
}
.respond-again {
	background-color: #EDF8DF;
	border: 1px solid #709F34;
	font-size: 12px;
	color: #709F34;
	padding: 7px 12px;
	width: 105px;
	height: 26px;
	float: right;
}
.respond-again:hover {
	background-color: transparent;
	border: 1px solid #709F34;
	color: #709F34;
}
.survey-expanded {
	background-color: #FFF !important;
}

.req-cnt {
	font-size: 11px;
	color: #525252;
	line-height: 13px;
}
.ml-35 {
	margin-left: 35px;
}
</style>
